import {Component, computed, input, TemplateRef, ViewChild} from '@angular/core';
import {constructHistoryColumns, HistoryColumn} from "./history-table.config";
import {TableData} from "../../../interfaces/table/table-data";

@Component({
  selector: 'history-table',
  templateUrl: './history-table.component.html',
  standalone: false
})
export class HistoryTableComponent {
  data = input.required<TableData>();
  columns = computed(() =>
    constructHistoryColumns(this.actionDescriptionColumn, this.userNameColumn, this.emailColumn));
  loading = input<boolean>(false);
  @ViewChild('actionDescriptionColumn', {static: true}) actionDescriptionColumn!: TemplateRef<any>;
  @ViewChild('userNameColumn', {static: true}) userNameColumn!: TemplateRef<any>;
  @ViewChild('emailColumn', {static: true}) emailColumn!: TemplateRef<any>;

  readonly systemUser = 'System';
  readonly hiddenRole = 'Developer';
  protected readonly HistoryColumn = HistoryColumn;
}
